export const FILE_PAGE_STATUS_VALUES = {
  pending: 'pending',
  processing: 'processing',
  done: 'done',
  error: 'error',
} as const;

export type FilePageStatus =
  (typeof FILE_PAGE_STATUS_VALUES)[keyof typeof FILE_PAGE_STATUS_VALUES];

export const FILE_PAGE_STATUS_LABELS: Record<FilePageStatus, string> = {
  pending: 'Pending',
  processing: 'Processing',
  done: 'Done',
  error: 'Error',
};
